
import { defineComponent, watch } from 'vue'
import { useField } from 'vee-validate'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    modelValue: {
      type: String
    },
    title:{
      type: String,
      default: 'formularios.carVersion.title'
    }, 
    label: {
      type: String,
      default: 'formularios.carVersion.label'
    },
    placeholder: {
      type: String,
      default: 'formularios.carVersion.placeholder'
    },
    required: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n()
    const { value: field, errorMessage, meta } = useField(
      'carVersion',
      { required: props.required },
      {
        initialValue: props.modelValue,
        label: t(props.label).toString().toLowerCase()
      }
    )

    watch(field, val => emit('update:modelValue', val))
    return {
      t,
      field,
      errorMessage,
      meta
    }
  }
})
